import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getKhattabat101CStore from "../../../../stores/khattabat-stores/101c-stores";
import getKhattabat101MessagingStore from "../../../../stores/khattabat-stores/messaging-stores/101-messaging-store";
import getKhattabat102MessagingStore from "../../../../stores/khattabat-stores/messaging-stores/102-messaging-store";
import getKhattabatSharedMessagingStore from "../../../../stores/khattabat-stores/messaging-stores/conversation-messaging-store";
import Body from "./body";
import KhattabatConversationHeader from "./header/KhattabatConversationHeader";

const KhattabatConversation = withLiteObserverAndTheme<{
  conversationID: string;
}>((props) => {
  const { conversationID } = props;

  const { conversationType, isOpened, toggleIsOpened } =
    getKhattabatSharedMessagingStore(conversationID);
  const clientID =
    conversationType.get() === "102"
      ? getKhattabat102MessagingStore(conversationID).clientReceiverID.get()
      : getKhattabat101MessagingStore(conversationID).receiverID.get();
  const { isOneOOneCHiddenByKhattaba } = getKhattabat101CStore(clientID);

  const isOneOneCConversation = conversationType.get() === "101C";
  const shouldNotShow =
    isOneOneCConversation && isOneOOneCHiddenByKhattaba.get();

  return shouldNotShow ? null : (
    <Accordion
      expanded={isOpened.get() === "OPENED"}
      onChange={toggleIsOpened}
      disableGutters
      elevation={0}
      square
      sx={{ width: "100%" }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <KhattabatConversationHeader conversationID={conversationID} />
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <Body conversationID={conversationID} userID={clientID} />
      </AccordionDetails>
    </Accordion>
  );
});

export default KhattabatConversation;
